import { lang } from '../provider';

/**
 * Pack of lang terms for the Prometheus SimpleRtfEditor component
 */
export function getSimpleRtfEditorI18n() {
    return {
        bold: lang.main("Rtf_Toolbar_Bold"),
        italic: lang.main("Rtf_Toolbar_Italic"),
        underline: lang.main("Rtf_Toolbar_Underline"),
        nList: lang.main("Rtf_Toolbar_Numbered_List"),
        bList: lang.main("Rtf_Toolbar_Bullet_List"),
        heading: lang.main("Rtf_Toolbar_Heading"),
        link: lang.main("Rtf_Toolbar_Link"),
        insertLinkTitle: lang.main("Rtf_Insert_Link_Dialog_Title"),
        editLinkTitle: lang.main("Rtf_Edit_Link_Dialog_Title"),
        insert: lang.main("Rtf_Insert_Button"),
        save: lang.main("Save"),
        cancel: lang.main("Cancel"),
        removeLink: lang.main("Rtf_Remove_Link_Button"),
        urlAddress: lang.main("Rtf_Url_Address"),
        requiredField: lang.main("Required_field"),
        invalidUrl: lang.main("Rtf_Url_Is_Invalid"),
        langSelector: lang.main("Set_text_language_tag"),
        removeLanguage: lang.main("Remove_language_tag"),
        langDescription: lang.main("Choose_the_text_language_to_add_a_tag"),
        skipLink: lang.main("Skip_editor"),
    }
};
